import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { GetFileSizeStringService } from '../shared/getFileSize/get-file-size-string.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import * as globals from '../globals';

export class S3Object {
  public isFolder: boolean;
  public key: string;
  public name: string;
  public type: number;
  public sizebytes: number;
  public size: string;
  public createddate: string;
}

export class BreadCrumb {
  public levelid: number;
  public foldername: string;
  public key: string;
}
export class BreadCrumbInfo {
  public breadcrumbkey: string;
  public level: number;
}

@Injectable()
export class ProjectsInfoService {
  private projectsUrl = globals.APIURL + '/projects';
  private breadcrumbStringkey: string;
  private mapS3objArray: Array<S3Object> = [];
  private level: number;
  private currentLevelObj: Array<S3Object> = [];
  private currentFolderArray: Array<S3Object> = [];
  private currentFilesArray: Array<S3Object> = [];
  private breadCrumbInfo: BreadCrumbInfo = new BreadCrumbInfo();
  private breadCrumbArray: any = {};
  private bucketname = globals.BUCKETNAME;

  constructor(private http: Http, private getFileSizeStringService: GetFileSizeStringService, private getFileTypeService: GetFileTypeService, public authHttp: AuthHttp) { }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }
  private extractTextData(res: Response) {
    let body = res.text();
    // console.log('BODY:', body);
    return body || {};
  }

  getProjectAttachments(tenantid: string, tenanturl: string, Projectid: String, prefixString: string, folderClicked: boolean, bcoccurant: number): Observable<{}> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    // Parameters obj-
    let params: URLSearchParams = new URLSearchParams();
    if (this.breadcrumbStringkey && folderClicked) {
      this.breadcrumbStringkey = this.breadcrumbStringkey + '/' + prefixString;
      // this.breadCrumbArray.push({levelid: 1, foldername: prefixString, key: this.breadcrumbStringkey });
      let bcoccurances = (this.breadcrumbStringkey.match(new RegExp('/' + prefixString, 'g')) || []).length;
      if (bcoccurances === 1) {
        this.breadCrumbArray[prefixString] = [this.breadcrumbStringkey, bcoccurances++];
      } else if (bcoccurances > 1) {
        this.breadCrumbArray[prefixString + bcoccurances] = [this.breadcrumbStringkey, bcoccurances++];
      }
    } else if (this.breadcrumbStringkey && !folderClicked) {
      if (bcoccurant > 1) {
        this.breadcrumbStringkey = this.getkeyFrombreadcrumbDict(prefixString + bcoccurant);
      } else {
        this.breadcrumbStringkey = this.getkeyFrombreadcrumbDict(prefixString);
      }
    } else {
      this.breadcrumbStringkey = this.bucketname + '/' + tenantid + '/' + Projectid + '/' + prefixString;
      // this.breadCrumbArray.push({levelid: 1, foldername: prefixString, key: this.breadcrumbStringkey });
      let bcoccurances = (this.breadcrumbStringkey.match(new RegExp('/' + prefixString, 'g')) || []).length;
      if (bcoccurances === 1) {
        this.breadCrumbArray[prefixString] = [this.breadcrumbStringkey, bcoccurances++];
      } else if (bcoccurances > 1) {
        this.breadCrumbArray[prefixString + bcoccurances] = [this.breadcrumbStringkey, bcoccurances++];
      }
    }

    console.log('PREFIX:', this.breadcrumbStringkey);

    params.set('prefix', this.breadcrumbStringkey);
    //  params.set('delimiter', '/');

    let options = new RequestOptions({ body: '', headers: headers, params: { prefix: this.breadcrumbStringkey } });
    console.log('Projects Attachment: OPTIONS =>', options);
    console.log('URL:', tenanturl);
    return this.http.get(tenanturl, options)
      .map(this.extractTextData)
      .catch(this.handleError);
  }

  DeleteProjectAttachmentFile(tenanturl: string, filename: string, deleteFolder: boolean, filekey: string): Observable<{}> {
    let deleteFileUrl: any;
    if (!deleteFolder) {
      deleteFileUrl = tenanturl + '/' + this.getCurrentBreadcrumbPath() + '/' + filename;
    } else {
      deleteFileUrl = tenanturl + '/' + filekey;
    }
    let headers = new Headers({
    });
    let params: URLSearchParams = new URLSearchParams();
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects Attachment: OPTIONS =>', options);
    console.log('DELETE URL:', deleteFileUrl);
    return this.http.delete(deleteFileUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  parseAttachmentDataToFolder(listContentArray: any) {
    this.mapS3objArray = [];
    for (let i = 0; i < listContentArray.length; i++) {
      // old internal method commented out below.
      // let filesize = this.getReadableFileSizeString(listContentArray[i].Size);
      let filesize = this.getFileSizeStringService.getReadableFileSizeString(listContentArray[i].Size);
      this.mapS3objArray.push({ isFolder: true, key: listContentArray[i].Key, name: listContentArray[i].name, type: 0, sizebytes: listContentArray[i].Size, size: filesize, createddate: listContentArray[i].LastModified });
    }

    return this.mapS3objArray;
  }

  getbreadCrumbinfo() {
    return this.breadCrumbInfo.breadcrumbkey;
  }

  refreshLevelData(mapS3objArray: Array<S3Object>, currentlevel: number, breadcrumb: string) {
    // this.breadcrumbStringkey = breadcrumb;
    this.breadCrumbInfo.breadcrumbkey = breadcrumb;
    // Occurance of breadcrumb within breadcrumb string
    let breadcrumbOccurance = (this.breadcrumbStringkey.match(new RegExp('/' + breadcrumb, 'g')) || []).length;
    console.log(' Occurance of BREADCRUMB : ' + (this.breadcrumbStringkey.match(new RegExp(breadcrumb, 'g')) || []).length + ' : so value : ' + breadcrumbOccurance);
    this.breadCrumbInfo.level = currentlevel;
    this.currentLevelObj = [];
    this.currentFolderArray = [];
    this.currentFilesArray = [];
    let occuranceCounter = 0;
    for (let i = 0; i < mapS3objArray.length; i++) {
      occuranceCounter = 0;
      let splittedkey = mapS3objArray[i].key.split('/');
      for (let j = 0; j < splittedkey.length; j++) {
        if (splittedkey[j] == breadcrumb) {
          occuranceCounter++;
          if (occuranceCounter == breadcrumbOccurance) {
            if (splittedkey[j + 1].includes('.')) {
              if (!this.isArrayContains(this.currentFolderArray, splittedkey[j + 1]) && (splittedkey[j + 1] !== '')) {
                let typeId = this.getFileTypeService.getFileTypeFromExtension(splittedkey[j + 1]);
                this.currentFolderArray.push({ isFolder: false, key: mapS3objArray[i].key, name: splittedkey[j + 1], type: typeId, sizebytes: mapS3objArray[i].sizebytes, size: mapS3objArray[i].size, createddate: mapS3objArray[i].createddate });
              }
            } else {
              if (!this.isArrayContains(this.currentFilesArray, splittedkey[j + 1]) && (splittedkey[j + 1] !== '')) {
                this.currentFilesArray.push({ isFolder: true, key: mapS3objArray[i].key, name: splittedkey[j + 1], type: 0, sizebytes: mapS3objArray[i].sizebytes, size: mapS3objArray[i].size, createddate: mapS3objArray[i].createddate });
              }
            }
          }
        }
      }
    }
    this.currentFolderArray.sort(this.sortOn('name'));
    this.currentFilesArray.sort(this.sortOn('name'));

    for (let i = 0; i < this.currentFilesArray.length; i++) {
      this.currentLevelObj.push(this.currentFilesArray[i]);
    }
    for (let i = 0; i < this.currentFolderArray.length; i++) {
      this.currentLevelObj.push(this.currentFolderArray[i]);
    }

    return this.currentLevelObj;
  }

  isArrayContains(fileFolderArray, name) {
    for (let i = 0; i < fileFolderArray.length; i++) {
      if (fileFolderArray[i].name == name) {
        return true;
      }
    }
    return false;
  }

  sortOn(property) {
    return function (a, b) {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      } else {
        return 0;
      }
    };
  }

  getkeyFrombreadcrumbDict(foldername: string) {
    let value, folder, valueArray;
    for (folder in this.breadCrumbArray) {
      if (folder == foldername) {
        valueArray = this.breadCrumbArray[folder];
        value = valueArray[0];
      }
      /* use key/value for intended purpose */
    }
    return value;
  }

  getSplittedBreadcrumbDict(foldername: string, bcoccurant: number) {
    let breadcrumbkey, folder, index;


    let breadCrumbCurrent = this.createSplitBreadcrumbBykey(this.breadcrumbStringkey);
    let count = 0;
    for (let i = 0; i < breadCrumbCurrent.length; i++) {
      if (breadCrumbCurrent[i] == foldername) {
        count++;
      }
    }
    bcoccurant = count;

    if (bcoccurant > 1) {
      foldername = foldername + bcoccurant;
    }

    index = 0;
    let breadcrumbData = [];
    for (folder in this.breadCrumbArray) {
      if (folder == foldername) {
        let breadcrumbkeyArray = this.breadCrumbArray[folder];
        breadcrumbkey = breadcrumbkeyArray[0];
      }
    }

    breadcrumbData = this.createSplitBreadcrumbBykey(breadcrumbkey);
    return breadcrumbData;
  }

  createSplitBreadcrumbBykey(breadcrumbkey: string) {
    let breadcrumbData = [];
    breadcrumbData[0] = 'Attachments';
    let breadcrumbsplitAttach = breadcrumbkey.split('/Attachments/');
    if (breadcrumbsplitAttach[1] != null && breadcrumbsplitAttach[1] != 'undefined') {
      let breadcrumbDataArray = breadcrumbsplitAttach[1].split('/');

      for (let i = 0; i < breadcrumbDataArray.length; i++) {
        if (breadcrumbDataArray[i] != '') {
          breadcrumbData[i + 1] = breadcrumbDataArray[i];
        }
      }
    }
    return breadcrumbData;
  }
  getCurrentBreadcrumbPath() {
    return this.breadcrumbStringkey;
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/projectinfo/projectinfo.service.ts